import API from '../services/api';

const api = new API();
const URL_AI_CONTEXT = 'api/ai-context';

const getContext = () =>
    new Promise((resolve, reject) => {
        api.getJson(URL_AI_CONTEXT, {
            method: 'GET',
            credentials: 'include',
            unique: true,
            disableBrowserCache: true,
        })
            .then(response =>
                resolve({
                    answers: response?.value?.answers || {},
                    maxLengths: response?.value?.max_lengths || {},
                })
            )
            .catch(reject);
    });

const saveAnswers = answers =>
    new Promise((resolve, reject) => {
        api.getJson(URL_AI_CONTEXT, {
            method: 'POST',
            credentials: 'include',
            unique: true,
            body: { answers },
        })
            .then(response => resolve(response?.value?.answers || {}))
            .catch(reject);
    });

export default { getContext, saveAnswers };
